import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import {
  deleteReport,
  fetchReportById,
  handleDownloadReport,
} from "../utils/fetchReports";
import { useState, useEffect } from "react";
import {
  Divider,
  Spin,
  Button,
  Table,
  Image,
  Skeleton,
  Card,
  Popconfirm,
} from "antd";
import {
  DownloadOutlined,
  DeleteOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { statuses } from "./Reports";
import { fetchOrderByID } from "../utils/fetchOrders";

const { format } = new Intl.NumberFormat("es-CL", {
  style: "currency",
  currency: "CLP",
});

function Report() {
  const { report_id } = useParams();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ordersInfoByVariant, setOrdersInfoByVariant] = useState({});
  const [loadingDownload, setLoadingDownload] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const fetchReport = async () => {
      const report = await fetchReportById(report_id);
      console.log("report", report);
      const formatedReport = {
        ...report,
        details: report.details.reduce((acc, item) => {
          const existingItem = acc.find(
            (it) => it.variant_id === item.variant_id
          );
          if (existingItem) {
            existingItem.quantity += item.quantity;
          } else {
            acc.push(item);
          }
          return acc;
        }, []),
        orders: report.details.reduce((acc, item) => {
          const existingItem = acc.find(
            (it) => it.variant_id === item.variant_id
          );
          if (existingItem) {
            existingItem.orders.push(...item.orders);
          } else {
            acc.push(item);
          }
          return acc;
        }, []),
      };
      console.log("formatedReport", formatedReport);
      setReport(formatedReport);
      setLoading(false);
    };
    fetchReport();
  }, [report_id]);

  // "quantity": 2,
  // "variant_id": 221,
  // "variant_name": "Limón",
  // "product_id": 110,
  // "product_name": "Manga 20kg Turbo Clean 4kg",
  // "image": null,
  // "orders": [
  //     69545,
  //     69580
  // ]

  //need to make the table expandable when a row is clicked
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);

  const handleRowExpansion = async (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([record.variant_id]);
      setExpandedRow(record);

      if (!ordersInfoByVariant[record.variant_id]) {
        const newOrdersInfoByVariant = {
          ...ordersInfoByVariant,
          [record.variant_id]: [],
        };
        for (const order_id of record.orders) {
          const order = await fetchOrderByID(order_id);
          newOrdersInfoByVariant[record.variant_id].push(order[0]);
        }

        setOrdersInfoByVariant(newOrdersInfoByVariant);
      }
    }
  };

  const handleExpendadRowRender = (record) => {
    return (
      <div>
        {!ordersInfoByVariant[record.variant_id] ? (
          <Skeleton active />
        ) : (
          <div className="pl-8">
            {ordersInfoByVariant[record.variant_id].map((order) => (
              <Card key={order.order_id} className="mb-2 shadow-sm">
                <div className="flex gap-2 justify-between items-center">
                  {/* General Information about the order  */}
                  <div className="flex flex-col gap-2 w-1/3">
                    <p>
                      <span className="text-gray-500">Pedido:</span>{" "}
                      {order.daily_id}
                    </p>
                    <p>
                      <span className="text-gray-500">
                        Fecha de Agendamiento:
                      </span>{" "}
                      {new Date(order.created_at).toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}
                    </p>
                    <p>
                      <span className="text-gray-500">Cliente:</span>{" "}
                      {order.name}
                    </p>
                    <p>
                      <span className="text-gray-500">Dirección:</span>{" "}
                      {order.address}
                    </p>
                    <p>
                      <span className="text-gray-500">Comuna:</span>{" "}
                      {order.city}
                    </p>
                    <p>
                      <span className="text-gray-500">Vendedor:</span>{" "}
                      {order.seller_name}
                    </p>
                    <p className="font-semibold">
                      <span className="text-gray-500">Total:</span>{" "}
                      {format(order.amount)}
                    </p>
                  </div>
                  {/* List of Products*/}
                  <div className="w-1/4">
                    <p className="font-semibold">
                      Productos ({order.products.length}):
                    </p>
                    {order.products.map((product) => {
                      return (
                        <Card key={product.order_product_id}>
                          <p>
                            {product.quantity}x {product.product_name} -{" "}
                            {product.variant}: {format(product.price)}
                          </p>
                        </Card>
                      );
                    })}
                  </div>
                  {/* List of deliveries*/}
                  <div className="w-1/4">
                    <p className="font-semibold">
                      Entregas ({order.delivery_info_array.length}):
                    </p>
                    {order.delivery_info_array.map((delivery) => {
                      return (
                        <Card key={delivery.delivery_id}>
                          <p>
                            <span className="text-gray-500">
                              Fecha de Entrega:
                            </span>{" "}
                            {new Date(
                              delivery.delivery_date
                            ).toLocaleDateString("es-ES", {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                            })}
                          </p>
                          <p>
                            <span className="text-gray-500">Conductor:</span>{" "}
                            {delivery.driver_name}
                          </p>
                        </Card>
                      );
                    })}
                  </div>

                  {/* Link to the order*/}
                  <div>
                    <Link to={`/orders/${order.order_id}`}>Ver Pedido</Link>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    );
  };

  const columns = [
    {
      title: "Imagen",
      dataIndex: "image",
      key: "image",
      width: 80,
      render: (image) =>
        image ? (
          <Image src={image} alt="Producto" width={120} height={120} />
        ) : (
          <div className="flex justify-center items-center h-full bg-gray-100 rounded-md py-10 italic">
            <span className="text-gray-500">No hay imagen</span>
          </div>
        ),
    },
    {
      title: "Producto",
      dataIndex: "product_name",
      key: "product_name",
      width: 100,
      sorter: (a, b) => a.product_name.localeCompare(b.product_name),
    },
    {
      title: "Variante",
      dataIndex: "variant_name",
      key: "variant_name",
      width: 100,
      sorter: (a, b) => a.variant_name.localeCompare(b.variant_name),
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
      width: 80,
      sorter: (a, b) => a.quantity - b.quantity,
    },
    {
      title: "Acciones",
      dataIndex: "actions",
      key: "actions",
      width: 80,
      render: (_, record) => (
        <Link to={`/products/${record.product_id}`}>Detalles de Producto</Link>
      ),
    },
    Table.EXPAND_COLUMN,
  ];

  const handleDeleteReport = async () => {
    // Delete the reports from the database
    setLoading(true);
    await deleteReport(report_id);
    navigate("/reports");
  };

  return (
    <div>
      {/* Default Page */}
      {!loading && (
        <div>
          <div className="font-semibold text-xl">{report.report_name}</div>
          <div className="flex gap-2 justify-between items-center">
            <div className="flex flex-col">
              <div>
                <span className="text-gray-500">Fecha de creación:</span>{" "}
                {/* Poner fecha en lenguaje español natural */}
                {new Date(report.created_at).toLocaleDateString("es-ES", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })}
              </div>
              <div>
                <span className="text-gray-500">Estado:</span>{" "}
                {statuses(report?.status_percentage)[report?.status].component}
              </div>{" "}
              <div>
                <span className="text-gray-500">Porcentaje de estado:</span>{" "}
                {report.status_percentage}%
              </div>
              <div>
                <span className="text-gray-500">Rango de Fechas:</span>{" "}
                {report.start_date === report.end_date ? (
                  <span className="font-semibold">
                    {new Date(report.start_date).toLocaleDateString("es-ES", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                ) : (
                  <>
                    Desde{" "}
                    <span className="font-semibold">
                      {new Date(report.start_date).toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}
                    </span>{" "}
                    hasta{" "}
                    <span className="font-semibold">
                      {new Date(report.end_date).toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}
                    </span>
                  </>
                )}
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <Button
                type="primary"
                onClick={() => {
                  setLoadingDownload(true);
                  handleDownloadReport(report_id);
                  setLoadingDownload(false);
                }}
                loading={loadingDownload}
              >
                <DownloadOutlined />
                Descargar Reporte
              </Button>
              <Popconfirm
                title="¿Estás seguro de querer eliminar estos reportes?"
                onConfirm={handleDeleteReport}
                okText="Eliminar"
                cancelText="Cancelar"
                okButtonProps={{
                  className: "custom-confirm-delete-button",
                  style: {
                    backgroundColor: "#f5222d",
                    borderColor: "#f5222d",
                    color: "#fff",
                  },
                }}
              >
                <Button
                  type="link"
                  icon={<DeleteOutlined />}
                  danger
                  loading={loading}
                >
                  Eliminar
                </Button>
              </Popconfirm>
            </div>
          </div>
          <Divider />
          <Table
            rowKey={(record) => record.variant_id}
            columns={columns}
            dataSource={report.details}
            scroll={{ y: "calc(100vh - 420px)" }}
            pagination={{
              pageSize: 4,
              showSizeChanger: false,
              position: ["topRight"],
            }}
            expandIcon={({ expanded, onExpand, record }) => (
              <Button
                type="text"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent row click event
                  onExpand(record, e);
                }}
              >
                {/* Add some icon in each option */}
                {expanded ? (
                  <div className="flex items-center gap-2">
                    <UpOutlined />
                    Pedidos
                  </div>
                ) : (
                  <div className="flex items-center gap-2">
                    <DownOutlined /> Pedidos
                  </div>
                )}
              </Button>
            )}
            expandable={{
              expandedRowRender: handleExpendadRowRender,
              onExpand: handleRowExpansion,
            }}
          />
        </div>
      )}

      {/* Loading Page */}
      {loading && (
        <div className="flex justify-center items-center h-screen">
          <Spin />
        </div>
      )}
    </div>
  );
}

export default Report;
